module.exports = __webpack_public_path__ + "media/images/icon-journey-1c9e027cb1fafb23fb2da66433f94c3d.svg";